import { Avatar, Flex, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { IUserOrg } from 'stores/orgStore';
import { useStores } from 'stores/rootStore';

interface Props {
  onSelectOrg: (org: IUserOrg) => void;
}

const OrgList = ({ onSelectOrg }: Props) => {
  const { orgStore } = useStores();
  const userOrgs = orgStore.orgs ?? [];

  const onSelectOrgCallback = useCallback(
    (org: IUserOrg) => () => {
      onSelectOrg(org);
    },
    [onSelectOrg],
  );

  return (
    <Flex flexDirection="column" gap={4}>
      {userOrgs.map((org) => (
        <Flex
          key={org.id}
          flexDirection="row"
          gap={2}
          alignItems="center"
          _hover={{ bg: 'surface.hover' }}
          p={2}
          borderRadius="md"
          cursor="pointer"
          onClick={onSelectOrgCallback(org)}
          tabIndex={0}
        >
          <Avatar.Root shape="rounded" size="sm">
            <Avatar.Fallback name={org.name} />
          </Avatar.Root>
          <Text flexGrow={1}>{org.name}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default observer(OrgList);
